<template>
  <div class="main-page-container">
    <!-- <main-toolbar class="main-toolbar" v-if="auth"></main-toolbar> -->
    <!-- <div class="logo-wrapper-wrapper" :class="{ 'big-logo': isHomepage }">
      <div class="logo-wrapper" :class="{ 'big-logo': isHomepage }">
        <router-link :to="{ name: 'home' }" class="logo">
          <logo></logo>
        </router-link>
      </div>
    </div> -->

    <div class="main-content">
      <router-view></router-view>
    </div>

    <page-footer></page-footer>

    <v-snackbar
      bottom
      right
      :color="globalNotification && globalNotification.color"
      v-model="showGlobalNotification"
    >
      {{ globalNotification && globalNotification.text }}
    </v-snackbar>
  </div>
</template>

<script>

import Logo from '@/components/Logo';
import PageFooter from '@/components/PageFooter';
import MainToolbar from '@/containers/MainToolbar';
import { SET_GLOBAL_NOTIFICATION } from '@/store/mutationTypes';

export default {
  name: 'main-page-container',
  components: {
    Logo,
    MainToolbar,
    PageFooter,
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    isHomepage() {
      return this.$route.name === 'home';
    },
    globalNotification() {
      const stateColors = {
        error: 'red darken-3',
        success: 'green darken-3',
      };

      const notification = this.$store.state.globalNotification;

      return notification && { ...notification, color: stateColors[notification.status] };
    },
    showGlobalNotification: {
      get() {
        return !!this.globalNotification;
      },
      set(value) {
        if (!value) {
          this.$store.commit(SET_GLOBAL_NOTIFICATION, null);
        }
      },
    },
  },
};

</script>

<style scoped>

header {
  /*position: relative;*/
  display: flex;
  flex-direction: row;
  justify-content: center;

  margin-top: 10px;
  margin-bottom: 30px;
}

.main-toolbar {
  float: right;
  margin: 5px 10px 0 0;
}

.logo-wrapper {
  width: 100px;
  height: 60px;
  margin: 0 auto 5px auto;
  display: block;
  transition: width .5s;
}

.logo-wrapper.big-logo {
  width: 140px;

}

.logo-wrapper a {
  display: block;
  width: 100%;
  height: 100%;
}

.logo-wrapper-wrapper {
  transition: padding-top .5s, padding-bottom .5s;
}

.logo-wrapper-wrapper.big-logo {
  padding-top: 40px;
  padding-bottom: 10px;
}

.main-content {
  margin-top: 50px;
}

</style>



// WEBPACK FOOTER //
// src/containers/MainPageContainer.vue